import React from "react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function CoreMissionVision() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="core-mission-vision" ref={sectionRef} className="relative w-full py-24 md:py-32 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-full opacity-10 text-secondary" viewBox="0 0 1200 600" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,100 C300,100 400,500 600,500 C800,500 900,100 1200,100" stroke="currentColor" strokeWidth="2" vectorEffect="non-scaling-stroke" className={`transition-all duration-[2000ms] ease-out ${isVisible ? "path-draw-active" : "path-draw-hidden"}`} style={{
          strokeDasharray: 2000,
          strokeDashoffset: isVisible ? 0 : 2000
        }} />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-8 md:gap-16 lg:gap-24">
          {}
          <div className={`flex flex-col justify-center md:text-right transition-all duration-1000 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary tracking-tight">
                Our Mission
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
                The COHCC Foundation is dedicated to expanding economic
                opportunity for Colorado’s Hispanic entrepreneurs, leaders,
                youth, and families through strategic programs, impactful data,
                and community partnerships.
              </p>
              <div className="pt-4 md:flex md:justify-end">
                <Button asChild variant="link" className="text-primary font-semibold hover:text-secondary p-0 h-auto text-base group">
                  <Link to="/MissionVisionPage">
                    Read our full mission statement
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {}
          <div className="hidden md:flex justify-center h-full min-h-[300px] py-4">
            <Separator orientation="vertical" className={`w-[2px] bg-secondary h-full transition-all duration-1000 delay-500 ${isVisible ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0"}`} />
          </div>

          {}
          <div className="md:hidden w-full flex justify-center py-4">
            <Separator orientation="horizontal" className="w-24 h-[2px] bg-secondary" />
          </div>

          {}
          <div className={`flex flex-col justify-center md:pt-32 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary tracking-tight">
                Our Vision
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
                To be the leading catalyst for Hispanic economic prosperity in
                Colorado, creating a thriving ecosystem where every
                entrepreneur, leader, and family has the resources and
                opportunity to succeed. We are building the architecture of
                aspiration for generations to come.
              </p>
              <div className="pt-4">
                <Button asChild className="bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground transition-colors rounded-lg px-8 py-6 text-base font-medium shadow-lg hover:shadow-xl">
                  <Link to="/GetInvolvedPage">Join the Movement</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}